/* 
Google Tag Manager Triggers

Log in events values are stored in cookies:
- gtm_trigger = 0 - no action
- gtm_trigger = 2 - user logged in
*/
current_url = window.location.href;
if (current_url == "https://modloft.com/account/login") {
  document.cookie = "gtm_trigger=2; path=/";
} else if (current_url == "https://modloft.com/account") {
  cookies_array = document.cookie.split(";");
  for (var i = 0; i < cookies_array.length; i++) {
    if ((cookies_array[i] = "gtm_trigger=2")) {
      console.log("User logged in.");
      dataLayer.push({ event: "login" });
      document.cookie = "gtm_trigger=0; path=/";
      break;
    }
  }
} else {
  document.cookie = "gtm_trigger=0; path=/";
}

// Klaviyo form submission
window.addEventListener("klaviyoForms", function (e) {
  console.log("Klaviyo event listener.");
  if (e.detail.type == "submit") {
    dataLayer.push({ event: "subscribed" });
    console.log("User subscribed.");
  }
});

// Email subscribe submission
document.addEventListener("DOMContentLoaded", function (event) {
  var subscribe_form = document.getElementById("newsletter-static-newsletter");
  if (typeof subscribe_form != "undefined" && subscribe_form != null) {
    console.log("Subscription event listener.");
    subscribe_form.addEventListener("submit", function (e) {
      dataLayer.push({ event: "subscribed" });
      console.log("Subscription submitted.");
    });
  }
});

// Trade application submission see: trade-form.liquid:957
// dataLayer.push({ event: "applicationSubmitted" });

//Customer registration form submission
document.addEventListener("DOMContentLoaded", function (event) {
  var register_form = document.getElementById("register-customer");
  if (typeof register_form != "undefined" && register_form != null) {
    console.log("Registration form event listener.");
    register_form.addEventListener("submit", function (e) {
      dataLayer.push({ event: "signup" });
      console.log("Customer registration submitted.");
    });
  }
});
